import React, { useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../common/types';
import { useDispatch } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';
import { useStyles } from "./styles";
import * as Icons from "./iconComponents";
import { withStyles } from '@material-ui/core/styles';
import { useFormContext, Controller } from "react-hook-form";
import api from '../../store/api';
import {
  Box, Grid,
  Button, IconButton,
  TextField, Select, MenuItem,
  FormHelperText, FormControl, FormControlLabel,
  RadioGroup, Radio, Checkbox,
  Dialog, DialogTitle, DialogContent,
  InputAdornment
} from '@material-ui/core';
interface PcrWidgetProps extends IAppPropsWithRoute {

};

const ThankYou: React.FC<PcrWidgetProps> = (props) => { 
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const [selectedOption, setSelectedOption] = useState(false); 
    const state:any = props.location.state;
    React.useEffect(() => {  
         //console.log(props)    
         //console.log(state)    
        dispatch(showNavbar(false));
    }, [])
    
    const handleDone = async() => {
      const res = await api.updateaccesscode('accesscode=' + selectedOption + '&pcrid=' + state.id,null); 
      if(res.hasError === false)
      {           
        history.push("/patientCareRecord");
      }   
    
    }
    const handleOptionChange = () => {
       if(!selectedOption)
       {
        setSelectedOption(true);
       }
       else{
        setSelectedOption(false);
       }
      };
    
      const CustomRadio = withStyles({
        root: {
          width: '16px',
          height: '16px',
          color: '#eff0f2',
          '&$checked': {
            color: '#000',
          },
        },
        checked: {},
      })((props: any) => <Radio color="default" {...props} />);
      
    
      const CustomFormControlLabel = withStyles({
        label: {
          fontSize: '15px',
          marginLeft: '5px',
        },
      })(FormControlLabel);
      return (        
          <div className={classes.root}>
          <Grid container direction="column" className={classes.thankYouMain}>
            <Grid item xs={'auto'} sm={'auto'}>
              <div className={'icon'}>
                <Icons.ThankYouIcon />
              </div>
              <div className={'text1'}>Thank You</div>
              <div className={'paragraph'}>
                The patient record has been submitted successfully.
              </div>
              <div className={'paragraph'}>
                <div>Please share the following download code with the care team</div>
                <div>you have handed over to.</div>
              </div>
              <div className={classes.frame}>
                <div className={classes.downloadCode}>
                     PCR DOWNLOAD CODE
                </div>
                <div className={classes.downloadCodeno}>
                  {state!== undefined? state.accessCode:""} 
                </div>              
                </div>
    
              <div>
              <Box
                    borderBottom="2px solid #ececec"
                    height="2px"
                    marginTop="20px"
                    marginBottom="18px"
                    />
    
              </div>  
              <div className={classes.checkboxs}>
             {/* // <FormControl fullWidth > */}
              <FormControlLabel
                  control={<Checkbox className={classes.checkboxInput} />}
                  label='I have provided the above code to the receiving care team.'
                  checked={selectedOption}
                  onChange={(e: any) => { handleOptionChange() }}
              />
              <FormHelperText>{""}</FormHelperText>
              {/* </FormControl>            */}
              </div> 
                {/* <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '9px',paddingLeft:'25px' }}>
                <FormControlLabel
                    value="option1"
                    control={<CustomRadio style={{ width: '16px', height: '16px', backgroundColor: '#eff0f2' }} />}
                    label={<span style={{ fontSize: '10px', color: '#4a586a', fontFamily: 'Lato', fontWeight: 400 }}>I have provided the above code to the receiving care team.</span>}
                    labelPlacement="end"
                    //onChange={handleOptionChange}
                    checked={selectedOption === 'option1'}
                />
                </div>
                
                <div style={{ marginBottom: '9px',paddingLeft:'25px',marginLeft:"-259px" }}>
                <CustomFormControlLabel
                    value="option2"
                    control={<CustomRadio className="radiobutton" style={{ width: '16px', height: '16px', backgroundColor: '#eff0f2' }} />}
                    label={<span style={{ fontSize: '10px', color: '#4a586a', fontFamily: 'Lato', fontWeight: 400 }}>The receiving care team is not available.</span>}
                    labelPlacement="end"
                    //onChange={handleOptionChange}
                    checked={selectedOption === 'option2'}
                />
                </div>
                
                <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '29px',paddingLeft:'25px'}}>
                <CustomFormControlLabel
                    value="option3"
                    control={<CustomRadio className="radiobutton" style={{ width: '16px', height: '16px', backgroundColor: '#eff0f2' }} />}
                    label={<span style={{ fontSize: '10px', color: '#4a586a', fontFamily: 'Lato', fontWeight: 400 }}>Patient is no longer in care.</span>}
                    labelPlacement="end"
                    //onChange={handleOptionChange}
                    checked={selectedOption === 'option3'}
                />
                </div> */}  
              <Button className={classes.yellowBtn} onClick={handleDone}>
                Done
              </Button>
            </Grid>
          </Grid>
        </div>      
       
      );
    }

export default React.memo(withRouter(ThankYou));